import React, { useContext } from 'react';
const languagesNames = {
    fr: {
        fr: 'Français',
        en: 'Anglais',
        de: 'Allemand',
        it: 'Italien',
    },
    en: {
        fr: 'French',
        en: 'English',
        de: 'German',
        it: 'Italian',
    },
    de: {
        fr: 'Französisch',
        en: 'English',
        de: 'Deutsche',
        it: 'Italienisch',
    },
    it: {
        fr: 'Francese',
        en: 'Inglese',
        de: 'Tedesco',
        it: 'Italiano',
    },
};
const flags = {
    fr: 'FR',
    en: 'GB',
    de: 'DE',
    it: 'IT',
};
export class TranslationContext {
    constructor(currentLanguage, defaultLanguage, availableLanguages, updateContext) {
        this.currentLanguage = currentLanguage;
        this.defaultLanguage = defaultLanguage;
        this.availableLanguages = availableLanguages;
        this.updateContext = updateContext;
    }
    get language() {
        return this.currentLanguage || this.defaultLanguage;
    }
    get languages() {
        return this.availableLanguages;
    }
    get getUnlocalizedPath() {
        if (window.location.pathname.search('/' + this.language) === 0) {
            return window.location.pathname.replace('/' + this.language, '');
        }
        else {
            return window.location.pathname;
        }
    }
    setLanguage(language) {
        if (this.availableLanguages.includes(language)) {
            this.updateContext(new TranslationContext(language, this.defaultLanguage, this.availableLanguages, this.updateContext));
        }
        else {
            throw new Error(`Language ${language} is not available`);
        }
    }
    mapToCountryFlag(language) {
        return flags[language];
    }
    mapFromCountryFlag(country) {
        return this.availableLanguages.filter((lang) => this.mapToCountryFlag(lang) === country)[0];
    }
    mapToLanguageName(language) {
        return languagesNames[this.language][language];
    }
}
export const ReactTranslationContext = React.createContext(null);
export const useLanguageCode = () => {
    const translationContext = useContext(ReactTranslationContext);
    return [translationContext === null || translationContext === void 0 ? void 0 : translationContext.language, translationContext === null || translationContext === void 0 ? void 0 : translationContext.setLanguage.bind(translationContext)];
};
export const useUnlocalizedPath = () => {
    const translationContext = useContext(ReactTranslationContext);
    return translationContext === null || translationContext === void 0 ? void 0 : translationContext.getUnlocalizedPath;
};
//# sourceMappingURL=TranslationContext.js.map